export enum Role {
  DOCTORAL_CANDIDATE = 'doctoral-candidate',
  CYCLIC_DOCTORAL_CANDIDATE = 'cyclic-doctoral-candidate',
  FAST_DOCTORAL_CANDIDATE = 'fast-doctoral-candidate',
  LEGACY_DOCTORAL_CANDIDATE = 'legacy-doctoral-candidate',
  COORDINATING_ACADEMIC = 'coordinating-academic',
  MAIN_SUPERVISOR = 'main-supervisor',
  SUPERVISOR = 'supervisor',
  THESIS_COMMITTEE_MEMBER = 'thesis-committee-member',
  SALARY_SYSTEM_FOREMAN = 'salary-system-foreman',
  COORDINATOR = 'coordinator'
}
